import useAxios from '@/utilities/useAxios'

const DND_SERVICE = `${import.meta.env.VITE_DND_APP_BACKEND_URL}`

interface AssignRoleProps {
  sourceUserId: string
  roleIds: number[]
}

export const assignRole = async (data: AssignRoleProps) => {
  return await useAxios
    .post(`${DND_SERVICE}/v1/user-role/assign`, data)
    .catch((error) => console.error(error))
}
